module.exports = __webpack_public_path__ + "static/media/tiktok-colored.be8a5b88.png";